module.exports = __webpack_public_path__ + "img/papel_reciclado.f9fff88c.webp";